export const makeFilterUrl = (data) => {
    const params = new URLSearchParams();

    Object.keys(data).forEach((key) => {
        if (Array.isArray(data[key])) {
            data[key].forEach((value) => {
                params.append(`${key}[]`, value);
            });
        } else {
            params.append(key, data[key]);
        }
    });

    let url = `${location.origin}${location.pathname}`;

    if (params.size) {
        url = `${location.origin}${location.pathname}?${params
            .toString()
            .replace(/%5B%5D/g, "[]")}`;
    }

    window.history.pushState({}, "", url);
};

export const getFilterData = (formData) => {
    const filterData = {};

    formData.forEach((value, key) => {
        if (key === "search") {
            filterData[key] = value;
        } else {
            if (!filterData[key]) {
                filterData[key] = [];
            }

            filterData[key].push(value);
        }
    });

    return filterData;
};
